const commonHZ = '?enablejsapi=1&autoplay=1'
const videosData = [
    {
        series:'EP-5',
        productData:[
            {
                productName:'EP-5 5-25X56 FFP Illuminated VPR - Zero Stop - 34mm Tube',
                productSku:'EP5-5251VPR',
                // productVariant:"MIL / VPR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/ep-5-5-25x56-ffp-illuminated-reticle-with-zero-stop-34mm-tube",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP5-525-MIL-R.png?v=1772097447&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP5-5-25VPR_MIL.png?v=1772332979&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP5-5-25VPR_MIL_cb8c423c-4eba-4bef-bc86-5163ff34e269.png?v=1772332989&width=2000'
            },
            {
                productName:'EP-5 5-25X56 FFP Illuminated VPR - Zero Stop - 34mm Tube',
                productSku:'EP5-5250VPR',
                // productVariant:"MOA / VPR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/ep-5-5-25x56-ffp-illuminated-reticle-with-zero-stop-34mm-tube?variant=47017879798079",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP5-525-MOA-R.png?v=1772097457&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP5-5-25VPR_MOA_5cff71bc-c7e2-47f0-8770-326a8afae752.png?v=1772333021&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP5-5-25VPR_MOA.png?v=1772333002&width=2000'
            },
            {
                productName:'EP-5 GENII 7-35X56 FFP Illuminated VPR - Zero Stop - 34mm Tube',
                productSku:'EP5GII-7351VPR',
                productVariant:"MIL / VPR",
                // productVariant:"",
                productLink:"https://arkenoptics.com/products/arken-ep-5-7-35x56-gen-2-ffp-illuminated-vpr-zero-stop-34mm-tube",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP-5Gen2-Reticles-MIL.png?v=1770107427&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP-5-7-35_MIL.png?v=1772333219&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP-5-7-35_MIL_1eaa4f6f-e37f-4f4b-96ab-63b7dc856ecd.png?v=1772333257&width=2000'
            },
            {
                productName:'EP-5 GENII 7-35X56 FFP Illuminated VPR - Zero Stop - 34mm Tube',
                productSku:'EP5GII-7350VPR',
                productVariant:"MOA / VPR",
                // productVariant:"",
                productLink:"https://arkenoptics.com/products/arken-ep-5-7-35x56-gen-2-ffp-illuminated-vpr-zero-stop-34mm-tube?variant=51140982604095",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP-5Gen2-Reticles-MOA.png?v=1770107427&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP-5-7-35_MOA.png?v=1772333242&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP-5-7-35_MOA_a4a1e221-5925-4456-8b37-3bf08e34c812.png?v=1772333267&width=2000'
            }
        ]
    },
    {
        series:'EP-8',
        productData:[
            // {
            //     productName:'EP-8 1-8x28 FFP LPVO | Illum. KLBOX | 34mm Tube',
            //     productSku:'EP8-18KLB',
            //     productVariant:"EP-8 Standard",
            //     productLink:"https://www.arkenoptics.com/products/ep-8-1-8x28-ffp-lpvo-illum-klbox-34mm-tube?variant=44163487400022",
            //     thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP8-Reticles.png?v=1772272958&width=800',
            //     previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP-8-1-8_d1d5ad0a-a3b0-4310-96d5-cfc6d9f7dd01.png?v=1772333551&width=2000',
            //     previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP-8-1-8.png?v=1772333534&width=2000'
            // },
            {
                productName:'EP-8 1-8x28 FFP LPVO | Illum. KLBOX | 34mm Tube',
                productSku:'EP8-18KLB / EP8-18KLB-M',
                // productVariant:"EP-8 Leveled and Installed",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/ep-8-1-8x28-lpvo-ffp-illuminated-reticle-34-mm-tube",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP8-Reticles.png?v=1772272958&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP-8-1-8_d1d5ad0a-a3b0-4310-96d5-cfc6d9f7dd01.png?v=1772333551&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/EP-8-1-8.png?v=1772333534&width=2000'
            }
        ]
    },
    {
        series:'EPL-4',
        productData:[
            {
                productName:'EPL-4 6-24X50 FFP Illuminated VHR/VPR - Zero Stop - 30mm Tube',
                productSku:'EPL4-6241VHR',
                // productVariant:"MIL / VHR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/epl-4-6-24x50-ffp-illuminated-reticle-with-zero-stop-30mm-tube?variant=47017862529343",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR-MIL_f78c4afb-fb01-493b-87a3-b11f3342a691.png?v=1772422324&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR_MIL_95843d5e-c630-4123-b096-0c9889847a4d.png?v=1772422325&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR_MIL_M_522529c1-42c8-46a5-8bc4-212b94d4213e.png?v=1772422324&width=2000'
            },
            {
                productName:'EPL-4 6-24X50 FFP Illuminated VHR/VPR - Zero Stop - 30mm Tube',
                productSku:'EPL4-6240VHR',
                // productVariant:"MOA / VHR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/epl-4-6-24x50-ffp-illuminated-reticle-with-zero-stop-30mm-tube?variant=47017862594879",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR-MOA_26c90bc1-a24d-4a4f-b5f1-677097128f60.png?v=1772422324&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR_MOA_5b728896-0389-42d9-bbae-3873c36999fb.png?v=1772422325&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR_MOA_M_0978bed1-9ab4-4fe7-8aa2-1c6607563b3d.png?v=1772422323&width=2000'
            },
            {
                productName:'EPL-4 6-24X50 FFP Illuminated VHR/VPR - Zero Stop - 30mm Tube',
                productSku:'EPL4-6241VPR',
                // productVariant:"MIL / VPR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/epl-4-6-24x50-ffp-illuminated-reticle-with-zero-stop-30mm-tube?variant=52950410199359",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR-MIL.png?v=1772422324&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR_MIL-1.png?v=1772422326&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR_MIL_M.png?v=1772422324&width=2000'
            },
            {
                productName:'EPL-4 6-24X50 FFP Illuminated VHR/VPR - Zero Stop - 30mm Tube',
                productSku:'EPL4-6240VPR',
                // productVariant:"MOA / VPR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/epl-4-6-24x50-ffp-illuminated-reticle-with-zero-stop-30mm-tube?variant=52950410232127",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR-MOA.png?v=1772422324&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR_MOA.png?v=1772422325&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR_MOA_M.png?v=1772422324&width=2000'
            },
            {
                productName:'EPL-4 4-16X44 FFP Illuminated VHR - Zero Stop - 30mm Tube',
                productSku:'EPL4-4161VHR',
                // productVariant:"MIL / VHR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/epl-4-4-16x44-ffp-illuminated-reticle-with-zero-stop-30mm-tube",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR-MIL.png?v=1772421988&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR_MIL.png?v=1772421988&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR_MIL_M.png?v=1772421988&width=2000'
            },
            {
                productName:'EPL-4 4-16X44 FFP Illuminated VHR - Zero Stop - 30mm Tube',
                productSku:'EPL4-4160VHR',
                // productVariant:"MOA / VHR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/epl-4-4-16x44-ffp-illuminated-reticle-with-zero-stop-30mm-tube?variant=47017870688575",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR-MOA.png?v=1772421988&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR_MOA.png?v=1772421988&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VHR_MOA_M.png?v=1772421987&width=2000'
            },
        ]
    },
    {
        series:'SH-4',
        productData:[
            {
                productName:'SH-4 GENII 4-16X50 FFP Illuminated VHR/VPR - Zero Stop - 34mm Tube',
                productSku:'SH4GII-4161VPR',
                // productVariant:"MIL / VPR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/sh-4-4-16x50-gen2-ffp-illuminated-reticle-with-zero-stop-34mm-tube?variant=47018126213439",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH-4-GEN2-Reticle-mil.png?v=1772266188&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4_MIL_461397bd-c01f-4c15-91b2-21b3407cb99c.png?v=1772336150&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4_MIL.png?v=1772336140&width=2000'
            },
            {
                productName:'SH-4 GENII 4-16X50 FFP Illuminated VHR/VPR - Zero Stop - 34mm Tube',
                productSku:'SH4GII-4160VPR',
                // productVariant:"MOA / VPR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/sh-4-4-16x50-gen2-ffp-illuminated-reticle-with-zero-stop-34mm-tube?variant=47018126246207",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH-4-GEN2-Reticle-moa.png?v=1772266204&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4_MOA_b462cd18-9387-435f-ab41-906723228d4c.png?v=1772336146&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4_MOA.png?v=1772336140&width=2000'
            },
            {
                productName:'SH-4 GENII 4-16X50 FFP Illuminated VHR/VPR - Zero Stop - 34mm Tube',
                productSku:'SH4GII-4161VHR',
                // productVariant:"MIL / VHR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/sh-4-4-16x50-gen2-ffp-illuminated-reticle-with-zero-stop-34mm-tube?variant=52962141241663",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-MIL-VHR.png?v=1772275829&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-_VHR_MIL.png?v=1772335928&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-_VHR_MIL_c537b834-9a1e-4304-a9e2-a698b940333c.png?v=1772335988&width=2000'
            },
            {
                productName:'SH-4 GENII 4-16X50 FFP Illuminated VHR/VPR - Zero Stop - 34mm Tube',
                productSku:'SH4GII-4160VHR',
                // productVariant:"MOA / VHR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/sh-4-4-16x50-gen2-ffp-illuminated-reticle-with-zero-stop-34mm-tube?variant=52962141274431",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-MOA-VHR.png?v=1772275829&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-_VHR_MOA.png?v=1772335932&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-VHR_MOA.png?v=1772336009&width=2000'
            }
        ]
    },
    {
        series:'SH-4J',
        productData:[
            {
                productName:'SH-4J 6-24X50 FFP Illuminated VHR/VPR - Zero Stop - 34mm Tube',
                productSku:'SH4J-6241VHR',
                productVariant:"MIL / VHR",
                productLink:"https://arkenoptics.com/products/sh-4j-6-24x50-ffp-illuminated-reticle-with-zero-stop-34mm-tube?variant=47010928984383",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-MIL-VHR_03f65fc1-192c-41f2-ae04-cc18993b92c6.png?v=1772275836&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-_VHR_MIL.png?v=1772335928&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-_VHR_MIL_c537b834-9a1e-4304-a9e2-a698b940333c.png?v=1772335988&width=2000'
            },
            {
                productName:'SH-4J 6-24X50 FFP Illuminated VHR/VPR - Zero Stop - 34mm Tube',
                productSku:'SH4J-6240VHR',
                productVariant:"MOA / VHR",
                productLink:"https://arkenoptics.com/products/sh-4j-6-24x50-ffp-illuminated-reticle-with-zero-stop-34mm-tube?variant=47010929508671",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-MOA-VHR_b7688e0b-fe3b-43ff-9301-32d72ac82617.png?v=1772275836&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-_VHR_MOA.png?v=1772335932&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-VHR_MOA.png?v=1772336009&width=2000'
            },
            {
                productName:'SH-4J 6-24X50 FFP Illuminated VHR/VPR - Zero Stop - 34mm Tube',
                productSku:'SH4J-6241VPR',
                productVariant:"MIL / VPR",
                productLink:"https://arkenoptics.com/products/sh-4j-6-24x50-ffp-illuminated-reticle-with-zero-stop-34mm-tube?variant=52950409052479",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-MIL-VPR_0c0689f0-8a39-462d-ac43-cb08f40b9965.png?v=1772275836&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-VPR_MIL.png?v=1772335933&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-VPR_MIL_2798f726-2262-4bd8-9ea1-397eaea32e05.png?v=1772336009&width=2000'
            },
            {
                productName:'SH-4J 6-24X50 FFP Illuminated VHR/VPR - Zero Stop - 34mm Tube',
                productSku:'SH4J-6240VPR',
                productVariant:"MOA / VPR",
                productLink:"https://arkenoptics.com/products/sh-4j-6-24x50-ffp-illuminated-reticle-with-zero-stop-34mm-tube?variant=52950409085247",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-MOA-VPR_0dfec3e0-9e61-4e7a-bd16-df010facea31.png?v=1772275836&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-VPRMOA.png?v=1772335932&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/SH4J-VPRMOA_7b107cf7-6b4b-4524-a1df-bb2f85527596.png?v=1772336009&width=2000'
            }
        ]
    },
    {
        series:'LH-4',
        productData:[
            {
                productName:'LH-4 4-16x44 FFP | Capped Tool-less Turrets | Illum. VPR | 30mm Tube',
                productSku:'LH4-4161VPR',
                // productVariant:"MIL / VPR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/lh-4-4-16x44-ffp-capped-tool-less-turrets-illum-vpr-vhr-30mm-tube",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR-MIL_e6e35872-8796-40fb-ae5f-827f4522af82.png?v=1772422691&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR_MIL-1_5dd80dcf-3a28-4868-bed5-9be7e48224c2.png?v=1772422692&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR_MIL_M_2796953a-f024-49f0-98f1-b66d14149120.png?v=1772422691&width=2000'
            },
            {
                productName:'LH-4 4-16x44 FFP | Capped Tool-less Turrets | Illum. VPR | 30mm Tube',
                productSku:'LH4-4160VPR',
                // productVariant:"MOA / VPR",
                productVariant:"",
                productLink:"https://arkenoptics.com/products/lh-4-4-16x44-ffp-capped-tool-less-turrets-illum-vpr-vhr-30mm-tube?variant=51140996727103",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR-MOA_0a29bbfa-8987-414a-aa70-4d516415b111.png?v=1772422691&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR_MOA_60f3a263-7c2f-42ae-971d-666fc662cf83.png?v=1772422691&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/VPR_MOA_M_84ba1ce7-5609-451a-bb03-cc5cceb8c1d1.png?v=1772422691&width=2000'
            },
        ]
    },
    {
        series:'LH-6',
        productData:[
            {
                productName:'LH-6 1-6x24 SFP LPVO | Illum. KLBOX | 30mm Tube',
                productSku:'LH6-16KLB',
                productVariant:"",
                productLink:"https://arkenoptics.com/products/lh-6-1-6x24-sfp-lpvo-illum-klbox-30mm-tube",
                thumbnail:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/LH6-Reticles.png?v=1772268098&width=800',
                previewP:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/LH-6_a3772010-112d-490d-a521-1733747a53c6.png?v=1772335718&width=2000',
                previewM:'https://cdn.shopify.com/s/files/1/0701/0458/0182/files/LH-6_7d195172-41d3-4a15-af15-0ad206599f22.png?v=1772335710&width=2000'
            },
        ]
    },
]